module.exports = __webpack_public_path__ + "assets/img/wave.4370844b.svg";